"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Progress = void 0;
var _Progress = _interopRequireDefault(require("./Progress.styles"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var Progress = function Progress(props) {
  var ariaLabel = props.ariaLabel;
  var styles = (0, _Progress.default)(props);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
    className: styles['cc-Progress'],
    role: "progressbar",
    "aria-label": ariaLabel,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: styles['cc-Progress__percentage']
    })
  });
};
exports.Progress = Progress;